import { Box, Button, Divider, FormControl, Grid, IconButton, InputLabel, MenuItem, MenuList, Modal, Pagination, Popover, Select, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { Search, SearchIconWrapper, style, StyledInputBase, StyledTableCell, StyledTableRow } from "../../../styles/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { BsSearch } from "react-icons/bs";
import { Link } from "react-router-dom";
import { useGetLessonSessionsQuery } from "../../../api/lessonNoteApi";
import { toast } from "react-toastify";
import { formatDateTime } from "../../../utils";
import api from "../../../services/QualityAssurance";
import { useSelector } from "react-redux";
import TableLoader from "../../TableLoader";
import CalendarModal from "./Preview";
import { TrendingUpSharp } from "@mui/icons-material";

const events = [
  { date: "Sept. 18", title: "First Day of School", desc: "Lorem ipsum sit ibu lorem ipsum sit ibu..." },
  { date: "Sept. 18", title: "First Day of School", desc: "Lorem ipsum sit ibu lorem ipsum sit ibu..." },
  { date: "Sept. 18", title: "First Day of School", desc: "Lorem ipsum sit ibu lorem ipsum sit ibu..." },
  { date: "Sept. 18", title: "First Day of School", desc: "Lorem ipsum sit ibu lorem ipsum sit ibu..." },
  { date: "Sept. 18", title: "First Day of School", desc: "Lorem ipsum sit ibu lorem ipsum sit ibu..." },
  { date: "Sept. 18", title: "First Day of School", desc: "Lorem ipsum sit ibu lorem ipsum sit ibu..." },
  { date: "Sept. 18", title: "First Day of School", desc: "Lorem ipsum sit ibu lorem ipsum sit ibu..." },
  { date: "Sept. 18", title: "First Day of School", desc: "Lorem ipsum sit ibu lorem ipsum sit ibu..." },
];

const AcademicCalendarEnum = {
  InActive: 0,
  Active: 1,
  Publish: 2,
  Suspend: 3,
};

const statusStyles = {
  [AcademicCalendarEnum.InActive]: "bg-red-100 text-red-600",
  [AcademicCalendarEnum.Active]: "bg-green-100 text-green-600",
  [AcademicCalendarEnum.Publish]: "bg-purple-100 text-purple-600",
  [AcademicCalendarEnum.Suspend]: "bg-gray-100 text-gray-600",
};

const statusLabels = {
  [AcademicCalendarEnum.InActive]: "Inactive",
  [AcademicCalendarEnum.Active]: "Active",
  [AcademicCalendarEnum.Publish]: "Publish",
  [AcademicCalendarEnum.Suspend]: "Suspend",
};

export const CalenderTable = () => {
  const { admToken } = useSelector((state) => state.auth);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [selectedSessionId, setSelectedSessionId] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selected, setSelected] = useState([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [openPreviewModal, setPreviewOpenModal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [schoolYear, setSchoolYear] = useState({
    sessionId: 0,
    sessionName: ''
  });
  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 10,
    totalRecords: 0,
    totalPages: 0
  });
  const { data: sessions, isLoading: sessionsLoading } = useGetLessonSessionsQuery();

  const handlePreviewOpen = () => setPreviewOpenModal(true);
  const handlePreviewClose = () => setPreviewOpenModal(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false)
  const handleCloseDeleteModal = () => setOpenDeleteModal(false);
  const handleOpenDeleteModal = () => setOpenDeleteModal(true);

  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(item);
    setSelectedItemId(item.id);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleEdit = () => {
    handleClose();
    handleOpenModal();
  };


  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.getCalendars(
        admToken,
        searchText,
        pagination.pageSize,
        pagination.pageNumber,
      );
      if (res.status && res.statusCode === 2) {
        setData(res.data)
        setPagination(prev => ({
          ...prev,
          totalRecords: res.totalRecord,
          totalPages: Math.ceil(res.totalRecord / pagination.pageSize),
          currentPage: res.currentPage || 1
        }));
        setSelected([]);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  }, [admToken, searchText, pagination.pageSize, pagination.pageNumber]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const selectedSession = sessions?.data?.find(s => s.id === value);
    setSchoolYear(prev => ({
      ...prev,
      [name]: value,
      sessionName: selectedSession ? selectedSession.name : ''
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const payload = {
        sessionId: schoolYear.sessionId,
        sessionName: schoolYear.sessionName,
        id: selectedItemId
      }
      const res = await api.updateCalendar(admToken, payload);
      if (res.status && res.statusCode === 2) {
        toast.success(res.message);
      } else {
        toast.error(res.data.message);
      }
      handleCloseModal();
    } catch (error) {
      console.error("Error creating calendar:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (status) => {
    if (!selectedItemId) return;

    try {
      const res = await api.updateCalendarStatus(admToken, selectedItemId, status);
      if (res.status && res.statusCode === 2) {
        toast.success(res.message);
        fetchData();
        handleClose();
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.error("Error updating Status:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
    setPagination(prev => ({ ...prev, pageNumber: 1 }));
  };

  const handlePageChange = (event, newPage) => {
    setPagination(prev => ({ ...prev, pageNumber: newPage }));
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    fetchData();
  };

  const handleDelete = useCallback(async () => {
    setDeleting(true)
    try {
      if (!selectedItemId) return;
      const res = await api.deleteCalendar(admToken, selectedItemId);
      if (res.status && res.statusCode === 2) {
        toast.success(res.data.message);
        fetchData();
        handleCloseDeleteModal();
        handleClose();
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.error(error.response?.data?.message || "Failed to delete Calendar");
    } finally {
      setDeleting(false)
    }
  }, [admToken, selectedItemId, fetchData]);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <Box>
      <Box>
        <Box
          sx={{
            pt: 4,
            background: "rgba(103, 30, 120, 0.1)",
            height: "100px",
            pl: { xs: 2.5 },
          }}
          onSubmit={handleSearchSubmit}
        >
          <Search
            sx={{
              width: {
                lg: "345px",
                md: "330px",
                sm: "auto",
                xs: "auto",
                pl: { xs: 6 },
              },
            }}
          >
            <SearchIconWrapper>
              <BsSearch />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search…"
              inputProps={{ "aria-label": "search" }}
              value={searchText}
              onChange={handleSearchChange}
            />
          </Search>
        </Box>
        <TableContainer>
          <Table
            sx={{
              minWidth: 700,
              fontFamily: "Gilroy-Regular",
              borderRadius: "0",
            }}
            aria-label="customized table"
          >
            <TableHead
              sx={{ backgroundColor: "rgba(103, 30, 120, 0.1)", width: "100%" }}
            >
              <TableRow>
                <StyledTableCell>S/N</StyledTableCell>
                <StyledTableCell>School Year</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                <StyledTableCell>Date Created</StyledTableCell>
                <StyledTableCell>Created By</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ fontFamily: "Gilroy-Regular", width: "100%" }}>
              {loading ? (
                <StyledTableRow>
                  <StyledTableCell colSpan={6} align="center">
                    <TableLoader />
                  </StyledTableCell>
                </StyledTableRow>
              ) : data?.length > 0 ? (
                data?.map((item, index) => (
                  <StyledTableRow key={item.id || index}>
                    <StyledTableCell component="th" scope="row">{index + 1}</StyledTableCell>
                    <StyledTableCell>{item.sessionName}</StyledTableCell>
                    <StyledTableCell>
                      <span
                        className={`rounded px-2 py-1 text-sm font-medium ${statusStyles[item.status]}`}
                      >
                        {statusLabels[item.status]}
                      </span>
                    </StyledTableCell>
                    <StyledTableCell>{formatDateTime(item.dateCreated)}</StyledTableCell>
                    <StyledTableCell>{item.createdBy}</StyledTableCell>
                    <StyledTableCell>
                      <IconButton onClick={(e) => handleClick(e, item)}>
                        <MoreVertIcon />
                      </IconButton>
                    </StyledTableCell>
                  </StyledTableRow>
                ))
              ) : (
                <StyledTableRow>
                  <StyledTableCell colSpan={6} align="center">
                    No activities found
                  </StyledTableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
          {pagination.totalPages > 1 && (
            <Box sx={{ display: "flex", justifyContent: "end", mt: 3, mb: 2 }}>
              <Pagination
                count={pagination.totalPages}
                page={pagination.currentPage}
                onChange={handlePageChange}
                color="primary"
                sx={{
                  '& .MuiPaginationItem-root': {
                    color: '#671E78',
                  },
                  '& .Mui-selected': {
                    backgroundColor: 'rgba(103, 30, 120, 0.1)',
                  },
                }}
                showFirstButton
                showLastButton
              />
            </Box>
          )}
        </TableContainer>
      </Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box
          sx={{
            bgcolor: "#671E78",
            color: "#fff",
            fontFamily: "Gilroy-Regular",
            px: 3,
          }}
        >
          <MenuList sx={{ fontFamily: "Gilroy-Regular" }}>
            <MenuItem
              onClick={() => {
                const newStatus = selectedItem?.status === 0 ? 1 : 0;
                handleStatusChange(newStatus);
              }}
            >
              {selectedItem?.status === 0 ? "Activate" : "Deactivate"}
            </MenuItem>
            <MenuItem
              onClick={() => {
                setSelectedSessionId(selectedItem?.sessionId)
                handleEdit()
              }}
            >
              Edit
            </MenuItem>
            <Link to={`/qualityassurance/academic-calender/activities/${selectedItem?.id}/${selectedItem?.sessionId}`}>
              <MenuItem>View Activities</MenuItem>
            </Link>
            <MenuItem onClick={handlePreviewOpen}>Preview</MenuItem>
            <MenuItem onClick={() => handleStatusChange(2)}>Publish</MenuItem>
            <MenuItem onClick={() => handleStatusChange(3)}>Suspend</MenuItem>
            <MenuItem
              onClick={() => {
                if (selectedItem) {
                  handleClose();
                  handleOpenDeleteModal();
                }
              }}
            >
              Delete
            </MenuItem>
          </MenuList>
        </Box>
      </Popover>
      {/* Edit */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box align="right" sx={{}}>
            <IconButton onClick={handleCloseModal}>
              <HighlightOffIcon />
            </IconButton>
          </Box>
          <Box>
            <Typography
              variant="h4"
              sx={{ textAlign: "center", mb: 2, fontFamily: "Gilroy-Medium" }}
            >
              Edit Calender
            </Typography>
            <Divider />
          </Box>
          <Box p={3} sx={{ overflowY: "scroll", height: "450px" }}>
            <Grid item sm={6} xs={12}>
              <Box>
                <InputLabel
                  sx={{
                    mb: 1.5,
                    mt: 1,
                    fontSize: "12px",
                    fontWeight: "bolder",
                    color: "#000",
                    fontFamily: "Gilroy-Medium",
                  }}
                >
                  School Year
                </InputLabel>
                <FormControl fullWidth>
                  <Select
                    name="sessionId"
                    sx={{
                      fontFamily: "Gilroy-Regular",
                      border: "0.5px solid #671E78",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "1px solid #671E78",
                        },
                      },
                    }}
                    variant="outlined"
                    size="small"
                    value={selectedSessionId ?? schoolYear.sessionId ?? ""}
                    onChange={(e) => setSelectedSessionId(e.target.value)}
                    disabled={sessionsLoading}
                  >
                    {sessionsLoading ? (
                      <MenuItem disabled>Loading session...</MenuItem>
                    ) : !sessions?.data || sessions.data.length === 0 ? (
                      <MenuItem disabled>No session available</MenuItem>
                    ) : (
                      sessions.data.map((session) => (
                        <MenuItem
                          sx={{ fontFamily: "Gilroy-Regular" }}
                          value={session.id}
                          key={session.id}
                        >
                          {session.name}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Box mt={10}>
              <Button
                variant="contained"
                fullWidth
                sx={{ textTransform: "initial" }}
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Updating..." : "Update Calender"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
        aria-labelledby="delete-confirmation-modal"
      >
        <Box sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 4,
        }}>
          <Typography variant="h6" sx={{ fontFamily: "Gilroy-Medium", mb: 2 }}>
            Confirm Delete
          </Typography>
          <Typography variant="body1" sx={{ fontFamily: "Gilroy-Regular", mb: 3 }}>
            Are you sure you want to delete this question?
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button
              variant="outlined"
              onClick={handleCloseDeleteModal}
              sx={{ textTransform: 'initial', fontFamily: "Gilroy-Regular" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleDelete}
              sx={{
                textTransform: 'initial',
                fontFamily: "Gilroy-Regular",
                bgcolor: '#671E78',
                '&:hover': { bgcolor: '#4e165a' }
              }}
            >
              {deleting ? "Deleting.." : "Delete"}
            </Button>
          </Box>
        </Box>
      </Modal>
      <CalendarModal open={openPreviewModal} onClose={handlePreviewClose} events={events} />
    </Box>
  );
};